import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthDebug from './AuthDebug';

export default function NavBar() {
  const { currentUser, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const userGroups = currentUser?.['cognito:groups'] || [];
  const isAdminUser = userGroups.includes('oscar_admin_user');

  async function handleLogout() {
    try {
      // Just call logout - it will handle the redirect to Cognito
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  }

  const isActive = (path) => {
    // Special case: if we're at root "/" and checking "/agentic-observability", mark as active
    if (location.pathname === '/' && path === '/agentic-observability') {
      return true;
    }
    return location.pathname === path;
  };

  return (
    <nav className="side-nav">
      <div className="nav-brand">
        <Link to="/">
          <h1>OpenSearch SSA KB</h1>
        </Link>
      </div>
      
      <div className="nav-user">
        <span className="user-email">{currentUser?.email}</span>
      </div>

      <div className="nav-links">
        <Link 
          to="/recordings" 
          className={`nav-link ${isActive('/recordings') ? 'active' : ''}`} 
        >
          <span className="nav-icon">🎙️</span>
          Recordings
        </Link>
        <Link 
          to="/upload" 
          className={`nav-link ${isActive('/upload') ? 'active' : ''}`}
        >
          <span className="nav-icon">📤</span>
          Manual Upload
        </Link>
        <Link 
          to="/oscar" 
          className={`nav-link ${isActive('/oscar') ? 'active' : ''}`}
        >
          <span className="nav-icon">🤖</span>
          OSCAR
        </Link>

        <Link 
          to="/e2dsl" 
          className={`nav-link ${isActive('/e2dsl') ? 'active' : ''}`}
        >
          <span className="nav-icon">🔄</span>
          English to DSL
        </Link>

        <Link 
          to="/chat-with-logs" 
          className={`nav-link ${isActive('/chat-with-logs') ? 'active' : ''}`}
        >
          <span className="nav-icon">💬</span>
          Chat With Logs
        </Link>

        <Link 
          to="/agentic-observability" 
          className={`nav-link ${isActive('/agentic-observability') ? 'active' : ''}`}
        >
          <span className="nav-icon">🔍</span>
          Agentic Observability
        </Link>

        <Link 
          to="/feedback" 
          className={`nav-link ${isActive('/feedback') ? 'active' : ''}`}
        >
          <span className="nav-icon">💭</span>
          Feedback/Issues
        </Link>

        <div className={`nav-link ${isActive('/debug') ? 'active' : ''}`}>
          <span className="nav-icon">🐛</span>
          <AuthDebug />
        </div>

        {isAdminUser && (
          <Link 
            to="/kb" 
            className={`nav-link ${isActive('/kb') ? 'active' : ''}`}
          >
            <span className="nav-icon">📚</span>
            Knowledge Base
            <span className="dev-badge" title="Under Development">🚧</span>
          </Link>
        )}
        
        <Link 
          to="/dashboard" 
          className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
        >
          <span className="nav-icon">📊</span>
          Dashboard
          <span className="dev-badge" title="Under Development">🚧</span>
        </Link>
      </div>

      <div className="nav-footer">
        <button onClick={handleLogout} className="nav-logout-btn">
          <span className="nav-icon">🚪</span>
          Log Out
        </button>
      </div>
    </nav>
  );
}
//comment
